<template>
  <div class="auth-form">
    <div class="form">
      <md-field>
        <md-input-item
          v-if="step === 'inputMobile'"
          ref="mobile"
          name="mobile"
          type="digit"
          class="bordered mobile-input"
          v-model="form.mobile"
          v-validate="'required|betweenLength:8,13'"
          :error="errors.first('mobile')"
        >
          <div slot="left" class="mobile-prefix" @click="showSelector('country')">
            <span class="prefix-text">{{form.country}}</span>
            <md-icon name="arrow-down" size="sm"></md-icon>
          </div>
        </md-input-item>
        <md-selector
          class="mobile-prefix-selector"
          v-model="selectorVisible.country"
          :data="mobilePrefixList"
          default-value="+62"
          cancel-text="cancel"
          title="Mobile Prefix"
          max-height="400px"
          @choose="form.country = $event.text"
        ></md-selector>
        <div class="prop-tip" v-if="step !== 'inputMobile'">
          <div v-if="step === 'signup'">
            {{ $t('codeSentShort') }} {{ $route.query.mobile }}
          </div>
          <div v-if="step === 'login'">
            <div>{{ $t('welcome') }}</div>
            <div>{{ $t('fillPasswordLogin') }}</div>
          </div>
        </div>
        <div v-if="step === 'signup'">
          <md-input-item
            ref="code"
            name="code"
            class="bordered"
            v-model="form.code"
            :placeholder="$t('verificationCode')"
            type="digit"
            v-validate="'required|digits:6'"
            :error="errors.first('code')"
          >
            <md-button type="blue" slot="right" :inactive="codeButtonDisabled" @click="getCode">
              {{ codeButtonText }}
            </md-button>
          </md-input-item>
        </div>
        <div v-if="['login', 'signup'].includes(step)">
          <md-input-item
            ref="password"
            name="password"
            class="bordered"
            v-model="form.password"
            :placeholder="passwordPlaceholder"
            type="password"
            v-validate="'required|betweenLength:8,13'"
            :error="errors.first('password')"
          >
          </md-input-item>
        </div>
        <div v-if="step === 'login'" class="pop-link" @click="showPassDialog">
          {{ $t('forgottenPassword') }}
        </div>
      </md-field>
    </div>
    <div class="action-button">
      <md-button type="primary" round v-if="step === 'inputMobile'" @click="goToPassword">
        {{ $t('joinNow') }}
      </md-button>
      <md-button type="primary" round v-if="['login', 'signup'].includes(step)" @click="goToProduct">
        {{ $t('startNow') }}
      </md-button>
    </div>
  </div>
</template>

<script>
import { Button, Field, FieldItem, Icon, InputItem, Selector } from 'mand-mobile'

const Cookie = require('js-cookie')

export default {
  i18n: {
    messages: {
      en: {
        checkInfo: 'Invalid input, please check again',
        invalidMobile: 'Mobile number should be 8 - 13 digits.',
        invalidPassword: 'Password should be 8 - 16 characters.',
        invalidCode: 'Invalid Code',
        resend: 'Resend',
        send: 'Send',
        codeSentShort: 'The SMS verification code have been sent to',
        codeSent: 'The verification code has been sent. Please Kindly check.',
        slogon: 'New customers with minimum lending IDR 10,000 and above',
        fillPhone: 'Fill in your phone No.',
        welcome: 'Welcome back!',
        fillPasswordLogin: 'Please fill in your password to Login',
        verificationCode: 'Vertification code',
        fillPassword: 'Fill in your password',
        setPassword: 'Set your password',
        startNow: 'Start now',
        forgottenPassword: 'Forgetton your password?',
        getMoney: 'Start Your Lending',
        joinNow: 'Join Now',
      },
      id: {
        checkInfo: 'Masukan tidak valid, silakan periksa info Anda',
        invalidMobile: 'Nomor telepon harus 8 - 13 digit',
        invalidPassword: 'Kata sandi harus terdiri dari 8 - 16 digit dan angka',
        invalidCode: 'Kode salah',
        resend: 'Kirim ulang',
        send: 'Kirim',
        codeSentShort: 'Kode verifikasi SMS sudah dikirim ke',
        codeSent: 'Kode verifikasi telah dikirim. Silakan periksa.',
        slogon: 'Pendana baru dengan minimum pendanaan Rp 10,000 dan seterusnya',
        fillPhone: 'Isi nomor telepon Anda',
        welcome: 'Selamat datang kembali!',
        fillPasswordLogin: 'Mohon isi kata sandi Anda untuk Masuk',
        verificationCode: 'Kode verifikasi',
        fillPassword: 'Isi kata sandi Anda',
        setPassword: 'Atur kata sandi',
        startNow: 'Mulai',
        forgottenPassword: 'Lupa kata sandi Anda?',
        getMoney: 'Jadi Pendana Sekarang',
        joinNow: 'Masuk',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [Icon.name]: Icon,
    [InputItem.name]: InputItem,
    [Selector.name]: Selector,
  },
  data() {
    return {
      selectorVisible: {
        country: false,
      },
      form: {
        country: '+62',
        mobile: '',
        code: '',
        password: '',
      },
      mobilePrefixList: [
        {
          text: '+61',
          value: '+61',
        },
        {
          text: '+62',
          value: '+62',
        },
        {
          text: '+65',
          value: '+65',
        },
        {
          text: '+81',
          value: '+81',
        },
        {
          text: '+82',
          value: '+82',
        },
        {
          text: '+852',
          value: '+852',
        },
        {
          text: '+86',
          value: '+86',
        },
        {
          text: '+886',
          value: '+886',
        },
      ],
      codeCountdown: null,
      codeInterval: null,
      step: this.$route.query.step || 'inputMobile',
    }
  },
  computed: {
    inviteCode() {
      return this.$store.state.inviteCode
    },
    submitDisabled() {
      const enabled = this.form.mobile.length > 0 && this.form.code.length > 0 && this.form.password.length >= 6
      return !enabled
    },
    codeButtonText() {
      if (this.codeCountdown === null || this.codeCountdown <= 0) {
        return this.$t('resend')
      }
      return `${this.codeCountdown}s`
    },
    codeButtonDisabled() {
      return this.codeInterval !== null
    },
    passwordPlaceholder() {
      console.log('step', this.step)
      return {
        'signup': this.$t('setPassword'),
        'login': this.$t('fillPassword'),
      }[this.step]
    },
  },
  methods: {
    showSelector(name) {
      this.selectorVisible[name] = true
    },
    onSelectorChoose({ text, value }, name) {
      this.selectorText[name] = text
      this.form[name] = value
    },
    async goToPassword() {
      const valid = await this.$validator.validate()
      if (!valid) {
        return
      }
      try {
        let step = 'inputMobile'
        const mobile = `${this.form.country}${this.form.mobile}`
        this.$toast.loading('loading...')
        const response = await this.$http.get(`/auth/check-mobile?phone=${mobile}`)
        if (response.data.code === 'SUCCESS') {
          this.step = 'signup'
          await this.getCode()
        } else if (response.data.code === 'MOBILE_EXIST') {
          this.step = 'login'
        }
        this.$router.push({ name: this.$route.name, query: { step, mobile } })
      } catch (e) {
        console.error(e)
      } finally {
        this.$toast.hide()
      }
    },
    goToProduct() {
      if (this.step === 'signup') {
        this.signup()
      } else if (this.step === 'login') {
        this.login()
      }
    },
    clearValidate() {
      this.$nextTick(() => {
      })
    },
    startCountdown() {
      this.stopCountdown()
      this.codeCountdown = 60
      this.codeInterval = setInterval(() => {
        this.codeCountdown -= 1
        if (this.codeCountdown === 0) {
          clearInterval(this.codeInterval)
          this.codeInterval = null
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.codeInterval) {
        clearInterval(this.codeInterval)
        this.codeInterval = null
      }
      this.codeCountdown = 0
    },
    async getCode() {
      this.startCountdown()
      const composedMobile = this.form.mobile ? `${this.form.country}${this.form.mobile}` : this.$route.query.mobile
      const url = `/auth/register-code?phone=${composedMobile}`
      try {
        this.$toast.loading('loading...')
        const res = await this.$http.post(url)
        switch (res.data.code) {
          case 'SUCCESS': {
            this.$toast.succeed(this.$t('codeSent'))
            break
          }
          default: {
            this.stopCountdown()
            break
          }
        }
      } catch (error) {
        console.error(error)
        this.stopCountdown()
      } finally {
        this.$toast.hide()
      }
    },
    async signup() {
      this.form.mobile = this.form.mobile || this.$route.query.mobile
      const valid = await this.$validator.validateAll()
      if (!valid) return
      const payload = {
        username: this.$route.query.mobile,
        password: this.form.password,
        code: this.form.code,
        channel: Cookie.get('channel'),
        inviteCode: this.inviteCode,
      }
      try {
        this.$toast.loading('loading...')
        const response = await this.$http.post('/auth/register-with-mobile', payload)
        switch (response.data.code) {
          case 'SUCCESS': {
            Cookie.set('x-request-token', response.data.data.accessToken)
            this.$track({
              event: 'sign-up-success',
            })
            await Promise.all([
              this.$store.dispatch('reloadInvestor', { force: true }),
              this.$store.dispatch('reloadAccount', { force: true }),
            ])
            this.$router.push('/product')
            break
          }
          default: {
            break
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$toast.hide()
      }
    },
    async login() {
      const valid = await this.$validator.validate()
      if (!valid) return
      try {
        const payload = {
          username: this.$route.query.mobile,
          password: this.form.password,
        }
        this.$toast.loading('loading...')
        const response = await this.$http.post('/auth/login', payload)
        if (response.data.code === 'SUCCESS') {
          Cookie.set('x-request-token', response.data.data.accessToken)
          await Promise.all([
            this.$store.dispatch('reloadInvestor', { force: true }),
            this.$store.dispatch('reloadAccount', { force: true }),
          ])
          this.$router.push('/product')
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.$toast.hide()
      }
    },
    showPassDialog() {
      this.$emit('showPassDialog')
    },
  },
}
</script>

<style lang="stylus" scoped>
.form /deep/ {
  display: flex;
  align-items: center;
  .md-field {
    width: 100%;
  }
  .md-input-item {
    margin-bottom: 16px;
  }
  .prop-tip {
    margin: 20px 0 10px;
    font-size: 14px;
    color: #101010;
    line-height: 1.5em;
  }
  .pop-link {
    margin-top: 15px;
    font-size: 14px;
    color: #468ee4;
  }
}

.action-button /deep/ {
  margin-top: 15px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  .md-button {
    border-radius: 20px;
    .md-button-inner {
      font-size: 16px;
      font-weight: 500;
    }
  }
}
</style>
